<template>
  <CollapseItem class="filter-category" :class="visualStyle">
    <template v-slot:collapse-trigger>
      <div class="category-header">
        <div class="category-title-wrapper">
          <span class="category-icon" v-html="filterCategory.icon"></span>
          <h6 class="category-title">{{ filterCategory.label }}</h6>
        </div>
        <div class="collapse-trigger-wrapper">
          <span class="selected-filters-count" v-if="selectedFilters > 0">({{ selectedFilters }} filters)</span>
          <CollapseIcon class="category-collapse-indicator"/>
        </div>
      </div>
    </template>
    <template v-slot:collapse-content>
      <div class="category-content">
        <div v-for="item in filterCategory.items" :key="item.value">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" :id="'category-item_' + item.value + '_' + uuid"
                   :value="item.value" :checked="blockData?.includes(item.value)" @change="blockUpdated"/>
            <label class="form-check-label" :for="'category-item_' + item.value + '_' + uuid">{{ item.label }}</label>
          </div>
        </div>
      </div>
    </template>
  </CollapseItem>
</template>

<script>
import CollapseItem from "@/components/UI/CollapseItem";

import CollapseIcon from "@/assets/image/icons/icon-arrow-alternative.svg?inline";

let uuid = 0;

export default {
  name: "FilterCategoryBlock",
  components: { CollapseItem, CollapseIcon },
  props: {
    filterCategory: Object,
    blockData: Object,
    visualStyle: String,
  },
  computed: {
    selectedFilters()
    {
      console.log(this.blockData)
      if (!this.blockData) return 0;
      
      return this.blockData.length;
    }
  },
  methods: {
    blockUpdated(e)
    {
      this.$emit("updated", {
        category: this.filterCategory.key,
        value: e.target.value,
        checked: e.target.checked
      });
    }
  },
  beforeCreate()
  {
    this.uuid = uuid.toString();
    uuid += 1;
  }
}
</script>

<style lang="scss" scoped>
.filter-category
{
  background-color: white;
  border-radius: 5px;
  padding: 15px;

  margin-top: 10px;

  &:first-child
  {
    margin-top: 0;
  }
}

.category-header
{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  color: $primary-blue;
}

// https://vue-loader.vuejs.org/guide/scoped-css.html#deep-selectors
.category-icon
{
  min-width: 15px;
  display: inline-block;
  text-align: center;

  &::v-deep svg
  {
    fill: $primary-blue;
  }
}

.category-title
{
  display: inline;
  vertical-align: middle;
  margin: 0 0 0 10px;
}

.selected-filters-count
{
  color: $font-grey;
  margin-right: 5px;
}

.category-collapse-indicator
{
  transition: transform 0.15s ease;
  fill: $primary-blue;
}

::v-deep(.collapse-trigger__active) .category-collapse-indicator
{
  transform: rotate(-180deg);
}

.category-content
{
  margin-top: 10px;
  color: $font-dark;
}

.form-check-label
{
  margin-left: 5px;
}

  .filter-category.student-platform {
    background-color: transparent;
    width: 100%;
    height: 100%;
    padding: 10px 15px 15px 15px;
    background-image: url("~@/assets/image/platform/button/bb_filter_tab.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top;

    .category-icon  svg{
      fill: #082B42;
    }

    .category-title {
      font-weight: bold;
    }

    .category-content {
      color: white;
      padding-top: 10px;
    }
  }

</style>